import dayjs from 'dayjs'

export const currentYear = new Date().getFullYear()

export const monthNames = Array.from({ length: 12 }, (_, index) => index).map(
  month => dayjs(new Date(currentYear, month)).format('MMMM')
)

export const slicedMonthNames = monthNames.map(monthName =>
  monthName.slice(0, 3)
)
